<template>
  <el-container class="lida-content" style="height: 100%;">
    <!-- 左边部分 -->
    <el-aside :class="['lida-left', { collapsed: isMenuCollapsed }]" :style="{ width: isMenuCollapsed ? '64px' : '180px' }">
      <div class="logo-warp">
        <el-image
          class="logo-icon"
          :src="require('@/assets/home/new-logo.png')"
          fit="fill"
        ></el-image>
        <el-image
          v-if="!isMenuCollapsed"
          class="logo-text"
          :src="require('@/assets/home/logo-name.png')"
          fit="fill"
        ></el-image>
      </div>

      <lida-menu :collapsed="isMenuCollapsed" @toggle-collapse="toggleMenuCollapse"></lida-menu>
    </el-aside>

    <el-container>
      <!-- 头部 -->
      <el-header class="lida-header">
        <div class="header-left">
          <!-- 空白区域 -->
        </div>

        <div class="header-right">
          <!-- 导航菜单 -->
          <div class="header-nav">
            <!-- 下载APP -->
            <el-popover
              placement="bottom"
              width="240"
              trigger="hover"
            >
              <div class="download-qrcode-box">
                <div class="qrcode-item">
                  <img src="@/assets/qrLogin.png" class="qrcode-img" />
                  <p>iOS下载</p>
                </div>
                <div class="qrcode-item">
                  <img src="@/assets/qrLogin.png" class="qrcode-img" />
                  <p>安卓下载</p>
                </div>
              </div>
              <template #reference>
                <span class="nav-item">下载APP</span>
              </template>
            </el-popover>

            <span class="nav-divider"></span>

            <!-- 下载桌面端 -->
            <el-popover
              placement="bottom"
              width="280"
              trigger="hover"
            >
              <div class="desktop-download-box">
                <div class="desktop-top">
                  <img src="@/assets/qrLogin.png" class="qrcode-img" />
                  <p class="download-title">Windows下载</p>
                </div>
                <div class="download-link">
                  <span>https://www.panlei.cn/desktop/files/panlei.exe</span>
                  <el-button type="text" size="small" @click="copyDownloadLink">复制</el-button>
                </div>
              </div>
              <template #reference>
                <span class="nav-item">下载桌面端</span>
              </template>
            </el-popover>

            <span class="nav-divider"></span>

            <!-- 微信视频号 -->
            <el-popover
              placement="bottom"
              width="160"
              trigger="hover"
            >
              <div class="single-qrcode-box">
                <img src="@/assets/weixinerweima.png" class="qrcode-img" />
                <p>微信扫码关注</p>
              </div>
              <template #reference>
                <span class="nav-item">微信视频号</span>
              </template>
            </el-popover>

            <span class="nav-divider"></span>

            <!-- 微信公众号/服务号/专属客服 -->
            <el-popover
              placement="bottom"
              width="360"
              trigger="hover"
            >
              <div class="multi-qrcode-box">
                <div class="qrcode-item">
                  <img src="@/assets/weixinerweima.png" class="qrcode-img" />
                  <p>盘雷公众号</p>
                </div>
                <div class="qrcode-item">
                  <img src="@/assets/qiyeweixin.png" class="qrcode-img" />
                  <p>盘雷服务号</p>
                </div>
                <div class="qrcode-item">
                  <img src="@/assets/weixin.png" class="qrcode-img" />
                  <p>微信专属客服</p>
                </div>
              </div>
              <template #reference>
                <span class="nav-item" style="margin-right: 24px;">微信公众号/服务号/专属客服</span>
              </template>
            </el-popover>

            <template 
              v-for="(item, index) in headerMenus" 
              :key="index"
            >
              <span
                :class="['nav-item', { 'active': isActiveMenu(item.path) }]"
                @click="handleNavClick(item)"
              >
                {{ item.title }}
              </span>
              <span class="nav-divider" v-if="index === 0 || index === 1"></span>
            </template>
          </div>

          <!-- 开关按钮 -->
          <el-switch
            v-model="autoOrderSwitch"
            class="header-switch"
            active-color="#48A09C"
            @change="handleSwitchChange"
          />

          <!-- 联系客服 -->
          <el-popover
            placement="bottom"
            title="联系客服"
            width="200"
            trigger="click"
          >
            <div class="kefu-box">
              <div class="img-left">
                <img src="../../assets/weixinerweima.jpg" alt="" />
                <p class="infos">盘雷热线</p>
                <p class="phone">18982112314</p>
              </div>
              <div class="img-right">
                <p class="infos">
                  <i class="iconfont iconweixin"></i> 微信扫码加群咨询
                </p>
                <img src="../../assets/qiyeweixin.png" alt="" />
                <p class="infos">
                  <i class="iconfont iconweixin"></i> 微信扫码咨询
                </p>
                <img src="../../assets/weixin.png" alt="" />
              </div>
            </div>
            <template #reference>
              <div class="notification-icon">
                <i class="iconfont iconkefu"></i>
              </div>
            </template>
          </el-popover>

          <!-- 用户下拉菜单 -->
          <el-dropdown @command="dropdownClick">
            <span class="user-info">
              <el-avatar :size="32" :src="userAvatar">
                <i class="iconfont icon-yonghu"></i>
              </el-avatar>
              <span class="user-name">{{ user.realName || '刘铁军' }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="item.text"
                  v-for="(item, index) in dropdown"
                  :key="index"
                >
                  {{ item.text }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      
      <!-- 面包屑导航 -->
      <div class="breadcrumb-container" v-if="breadcrumbList.length > 1">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item 
            v-for="(item, index) in breadcrumbList" 
            :key="index"
            :to="index < breadcrumbList.length - 1 ? { path: item.path } : null"
          >
            {{ item.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      
      <!-- 中心部分 -->
      <el-main style="padding: 10px;">
        <div class="lida-main" >
          <router-view :key="$route.fullPath" v-if="forceUpdate"/>
        </div>
      </el-main>
    </el-container>
  </el-container>
  <!-- 微信的绑定和解绑   -->
  <WeChatBind
    :isBind="userInfo.wechatFlag === '1'"
    @refresh="handlerRefresh"
    callDialog
    ref="weChatBind"
    :isShow="showWeChat"
  ></WeChatBind>
</template>

<script>
import lidaMenu from "@/components/publicComponent/lidaMenu.vue";
import { logOut } from "@/common/js/common.js";
import { mapMutations, mapActions } from "vuex";
import WeChatBind from "@/module/systemModule/components/weChatBind.vue";
import breadcrumbUtils from "@/utils/breadcrumb";

export default {
  data() {
    return {
      dropdown: [
        {
          text: "退出",
        },
        {
          text: "修改密码",
        },
      ],
      src: require("../../assets/lida.png"),
      userInfo: {},
      tabListShowValue: {},
      showWeChat: false,
      user: {},
      forceUpdate:true,
      isMenuCollapsed: false,
      headerMenus: [
        { title: '销售中心', path: '/mysale/orderSetup' },
        { title: '新增报价单', path: '/mysale/addOfferOrder' },
        { title: '新增询价单', path: '/purchase/addInquiryPage' },
        { title: '自动接单', path: '/auto/order' },
      ],
      autoOrderSwitch: false,
      notificationCount: 0,
      userAvatar: require('@/assets/profile.png'),
      tempList: [
        {
          setTpCd: "PROFIT_POINTS", //利润点数
          value: "",
          files: [],
          list: [],
        },
        {
          setTpCd: "COLLECTION_QR_CODE", //收款码
          value: "",
          files: [],
          list: [],
        },
      ],
      breadcrumbList: [],
    };
  },
  components: {
    lidaMenu,
    WeChatBind,
  },

  methods: {
    ...mapMutations([
      "renewLDrouters", //更新导航集合
    ]),
    ...mapActions([
      "uWechatBind", //绑定微信号
    ]),
    ...mapActions("systemModule", [
      "getUserInfo", //请求用户信息的接口
      "getDisplayTabListOfHome",
      "userListUserSetByUserId", //获取批量修改列表
      "userSetUserSetBatch", //批量修改
    ]),
    ...mapMutations("mysaleMudule", ["setOfferSuccessType"]),
    ...mapMutations("homeModule", ["setUserInfos", "searchUserInfo"]),
    ...mapActions("homeModule", ["searchUserInfo"]),
    linkPage(path, state) {
      //跳转页面
      if (!state) {
        this.$router.push(path);
      }
    },
    dropdownClick(row) {
      switch (row) {
        case "退出":
          logOut();
          break;
        case "修改密码":
          this.$router.push("/system/accountNumber");
          break;
        default:
      }
    },
    changeNavs(e) {
      //选择的点击事件
      
      if(this.$route.path == e.props.name){
        this.forceUpdate = false
        setTimeout(()=>{
          this.forceUpdate = true
        },10)
        return
      }
      this.$router.push(
        this.navs.filter((v) => v.path === e.props.name).length
          ? this.navs.filter((v) => v.path === e.props.name)[0]
          : {
              meta: {
                title: "首页",
              },
              path: "/home/index",
              closable: true,
              active: true,
            }
      );
    },
    removeNavs(name) {
      //删除的点击事件
      if (name === this.activeNavs) {
        this.navs.splice(
          this.navs.findIndex((v) => v.path === name),
          1
        );
        this.$router.go(-1);
      } else {
        this.navs.splice(
          this.navs.findIndex((v) => v.path === name),
          1
        );
      }
      this.renewLDrouters([...this.navs]);
    },
    authRefresh(callback) {
      //刷新用户是否绑定了微信
      this.getUserInfo().then((res) => {
        let { code, data } = res.data;
        if (code === "0") {
          this.userInfo = data;
          this.setUserInfos(data);
          callback && callback(data.wechatFlag);
        }
      });
    },
    customerOfferSuccess(v) {
      if (v) {
        this.setOfferSuccessType(false);
        this.authRefresh((auth) => {
          this.$refs.weChatBind.dialogVisible = auth !== "1";
        });
      }
    },
    handlerRefresh() {
      this.authRefresh();
    },
    clickOrderSetup() {
      this.$router.push("/mysale/orderSetup");
    },

    clickOrderSetupOnMyProduct() {
      this.$router.push(`/mysale/orderSetup?tab=t2_${new Date()}`);
    },

    clickAddInquiryPage() {
      this.$router.push("/purchase/addInquiryPage");
    },

    clickAddOfferOrder() {
      this.$router.push({
        path: "/mysale/addOfferOrder",
      });
    },

    searchUser() {
      this.searchUserInfo({}).then((res) => {
        let { code, data } = res.data;
        if (code === "0") {
          this.user = data;
        }
      });
    },

    toggleMenuCollapse() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },

    handleNavClick(item) {
      this.$router.push(item.path);
    },

    isActiveMenu(path) {
      return this.$route.path.includes(path);
    },

    handleSwitchChange(value) {
      console.log('自动接单开关:', value);
      this.setAutoQuote(value);
    },

    handleNotification() {
      console.log('点击通知');
      // 这里添加通知的处理逻辑
    },

    copyDownloadLink() {
      const link = 'https://www.panlei.cn/desktop/files/panlei.exe';
      navigator.clipboard.writeText(link).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },

    getInfo() {
      this.userListUserSetByUserId().then((res) => {
        let { code, data } = res.data;
        if (code === "0" && data.length) {
          data.map((item) => {
            item.list = JSON.parse(item.files || "[]");
            item.files = [];
            if (item.setTpCd === "AUTO_QUOTE") {
              this.autoOrderSwitch = item.value === "1";
            }
          });
          this.tempList = data;
        }
      });
    },

    setAutoQuote(v) {
      var data = JSON.parse(JSON.stringify(this.tempList));
      data.map((item) => {
        item.files = item.files.length ? item.files[0] : "";
        if (item.setTpCd === "AUTO_QUOTE") {
          item.value = v ? '1' : '0';
        }
        delete item.list;
      });

      this.userSetUserSetBatch(data).then((res) => {
        let { code, data } = res.data;
        if (code === "0") {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          //更新页面数据
          this.getInfo();
        }
      });
    },
    
    updateBreadcrumb() {
      // 根据当前路由生成面包屑
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      this.breadcrumbList = breadcrumbUtils.buildBreadcrumb(matched, this.$route);
    },
  },
  computed: {
    navs() {
      if (
        this.$store.state?.LDrouters &&
        Object.keys(this.tabListShowValue).length
      ) {
        return this.$store.state.LDrouters?.filter((e) => {
          if (
            e.meta.title === "销售中心" &&
            this.tabListShowValue.SELLING_CENTRE_DISPLAY_ADMIN === "0"
          ) {
            return false;
          } else if (
            e.meta.title === "采购中心" &&
            this.tabListShowValue.PURCHASING_CENTER_DISPLAY_ADMIN === "0"
          ) {
            return false;
          }
          return true;
        });
      }
      return [];
    },
    activeNavs() {
      return this.navs.filter((v) => v.active).length
        ? this.navs.filter((v) => v.active)[0].path
        : "";
    },
    background() {
      //根据路由匹配主体背景颜色
      return this.$route.path === "/purchase/product" ? "#F2F5FA" : "#ffffff";
    },
    mainPadding() {
      //首页padding为0，其他页面为10px
      return this.$route.path === "/home/index" ? "0px" : "10px";
    },
  },
  async created() {
    //报价成功的回调
    this.customerOfferSuccess(this.$store.state.mysaleMudule.offerSuccessType);
    // 拿是否自动报价状态
    this.getInfo();
    this.searchUser();
    //后端要求这样写
    try {
      const { userId } = JSON.parse(localStorage.userInfo);
      const PURCHASING_DATA = await this.getDisplayTabListOfHome({
        setTpCd: "PURCHASING_CENTER_DISPLAY_ADMIN",
        sellerId: userId,
      });
      const SELLING_DATA = await this.getDisplayTabListOfHome({
        setTpCd: "SELLING_CENTRE_DISPLAY_ADMIN",
        sellerId: userId,
      });
      if (PURCHASING_DATA?.data?.data && SELLING_DATA?.data?.data) {
        this.tabListShowValue = {
          PURCHASING_CENTER_DISPLAY_ADMIN: PURCHASING_DATA.data.data.value,
          SELLING_CENTRE_DISPLAY_ADMIN: SELLING_DATA.data.data.value,
        };
      }
    } catch (error) {}
  },
  watch: {
    "$route": {
      handler(to) {
        this.updateBreadcrumb();
      },
      immediate: true
    },
    "$store.state.mysaleMudule.offerSuccessType"(v) {
      this.customerOfferSuccess(v);
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .lida-header .el-tabs {
  .el-tabs__item:first-child {
    //&.is-active {
    //  color: #FFF !important;
    //}
    //
    //background: #D84146 !important;
    //color: #FFF;
  }
}

.lida-content {
  background: @home-content-background;

  .lida-left {
    background: #fff;
    width: 180px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;

    .logo-warp {
      padding-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      padding-bottom: 20px;
      transition: padding 0.3s ease;

      .logo-icon {
        width: 20px;
        height: 23px;
      }

      .logo-text {
        width: 41px;
        height: 32px;
      }
    }

    img {
      margin: 0 auto;
      width: 30px;
    }
  }

  .lida-header {
    background: #ffffff;
    box-sizing: border-box;
    padding: 0 20px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 20px);
    margin: 0 auto;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .header-left {
      flex: 1;
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 24px;

      .header-nav {
        display: flex;
        align-items: center;
        gap: 0;

        .nav-item {
          font-size: 14px;
          color: #666666;
          cursor: pointer;
          transition: color 0.3s;
          white-space: nowrap;
          padding: 0 16px;
          position: relative;

          &:hover {
            color: @dh-color;
          }

          &.active {
            color: @dh-color;
            font-weight: 500;
          }
        }

        .nav-divider {
          width: 1px;
          height: 14px;
          background-color: #ccc;
        }
      }

      .header-switch {
        /deep/ .el-switch__core {
          width: 40px;
          height: 20px;
        }
      }

      .notification-icon {
        position: relative;
        cursor: pointer;
        font-size: 16px;
        color: #666666;
        transition: color 0.3s;

        &:hover {
          color: @dh-color;
        }

        .notification-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background: #ff4d4f;
          color: #fff;
          font-size: 12px;
          padding: 0 6px;
          border-radius: 10px;
          min-width: 18px;
          height: 18px;
          line-height: 18px;
          text-align: center;
        }
      }

      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        color: #333333;

        .user-name {
          font-size: 14px;
          color: #333333;
        }

        .el-icon-arrow-down {
          font-size: 12px;
          color: #999999;
        }
      }
    }

    .top-icon-btn-box {
      display: flex;
      align-items: center;

      .iconkefu,
      .iconshiyongshuoming {
        font-size: 16px;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    /deep/ .el-tabs__header {
      border: none;
      margin-bottom: 0;

      .el-tabs__nav {
        border: none !important;

        .el-tabs__item {
          height: 32px;
          margin-right: 5px;
          border: none !important;
          background: #dfe2e7;
          border-radius: 5px 5px 0 0;
        }

        .is-active {
          background: @dh-color;
          color: #fff;
          //background: #f2f5fa;
        }
      }

      .el-tabs__nav-prev,
      .el-tabs__nav-next {
        line-height: 30px;
      }
    }

    /deep/ .el-dropdown {
    }
  }

  .breadcrumb-container {
    padding: 12px 20px;
    width: calc(100% - 20px);
    margin: 10px auto 0;

    /deep/ .el-breadcrumb {
      font-size: 14px;
      line-height: 1;

      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: #999999;
          font-weight: 400;

          &:hover {
            color: @dh-color;
          }
        }

        &:last-child .el-breadcrumb__inner {
          color: #333333;
          font-weight: 500;
        }

        .el-breadcrumb__separator {
          color: #cccccc;
          margin: 0 8px;
        }
      }
    }
  }

  .lida-main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow-y: auto;
    &::-webkit-scrollbar {
  display: none;
}
    -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  }

//   .lida-main ::-webkit-scrollbar {
//   display: none;
// }
}

.kefu-box {
  display: flex;
  width: 500px;
  padding: 20px;
  justify-content: space-between;

  img {
    width: 240px;
  }

  .img-right,
  .img-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .infos {
      color: #808080;
      padding: 10px 0;

      .iconweixin {
        color: green;
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }

  .img-left {
    font-size: 16px;
    justify-content: space-around;

    .infos {
      width: 100%;
      color: #292929;
      padding: 15px 0;
      margin: 15px 0;
      font-size: 18px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }

    .phone {
      color: #00a39e;
      font-size: 30px;
      font-weight: 600;
    }
  }
}

.download-qrcode-box {
  display: flex;
  justify-content: space-around;
  padding: 20px 10px;

  .qrcode-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode-img {
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }
}

.desktop-download-box {
  padding: 20px;

  .desktop-top {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
    justify-content: center;

    .qrcode-img {
      width: 100px;
      height: 100px;
    }

    .download-title {
      font-size: 14px;
      color: #333;
      margin: 0;
      font-weight: 500;
    }
  }

  .download-link {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      font-size: 12px;
      color: #666;
      word-break: break-all;
      flex: 1;
    }

    .el-button {
      color: @dh-color;
      padding: 0;
    }
  }
}

.single-qrcode-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .qrcode-img {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
}

.multi-qrcode-box {
  display: flex;
  justify-content: space-around;
  padding: 20px 10px;

  .qrcode-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode-img {
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }
}
</style>
